//
// TextMetadata
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'

import { Text } from '../../../../components'

export const TextMetadata = observer(function TextMetadata({
    className,
    name,
    field,
    value,
    language,
    component,
    renderkey,
}) {
    let attributes = { className: 'layout-component ws-text' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style

    return <Text {...attributes}>{value}</Text>
})
